export default __webpack_public_path__ + "static/media/comparte.8d996e39.png";